import 'moment/min/locales';

import { Button, Icon, ObjectUtils, Table } from 'modules';
import moment from 'moment';
import React, { memo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';

import { Routes } from '../../../AppRoutes';
import {
  TableFilterInputText,
  TableFilterRangeTimeInput,
} from '../../../components/table-filter-inputs';
import { TableFilterInputSelect } from '../../../components/table-filter-inputs/select';
import { getLocaleKey } from '../../../languages';
import { BankService } from '../../../services';
import { AdminService } from '../../../services/admin';
import { useSelector } from '../../../store';
import { transactionWrapper } from '../components';

export const TransactionList = transactionWrapper(
  memo(
    () => {
      const navigate = useNavigate();

      const startOfMonth = moment().startOf('day');
      const endOfDay = moment().endOf('day');

      const coinsState = useSelector((state) => state.coins);
      const coinsOptions = ObjectUtils.getIn(coinsState, 'data', [], (arr) =>
        arr.map((item: any) => ({
          label: item.name,
          value: item.coinId,
        })),
      );
      const UsdId = 2;
      const ButId = 5;
      const DemoId = 4;
      const Gp2Id = 5;

      const [params, setParams] = useState<any>();
      const [currentData, setCurrentData] = useState(null as any);
      const [isCheckAdmin, setIsCheckAdmin] = useState<boolean>(false);
      const [forceUpdateTable, setForceUpdateTable] = useState<boolean>();

      const structure = [
        {
          name: 'CREATED DATE',
          key: 'createdAt',
          render: (item: any) =>
            item?.createdAt != null
              ? moment(item?.createdAt)
                  .locale(getLocaleKey())
                  .format('L HH:mm:ss')
              : 'N/A',
        },
        {
          name: 'USER',
          key: 'user',
          render: (item: any) => (
            <div className='user'>
              <div className='user__avatar'>
                <img
                  className={`user__avatar__image ${item?.user?.avatar == null ? 'image-error' : ''}`}
                  src={item?.user?.avatar ?? '/assets/images/no-image.jpg'}
                  onError={(event: any) => {
                    if (!event.target.classList.contains('image-error')) {
                      event.target.classList.add('image-error');
                    }
                    event.target.src = '/assets/images/no-image.jpg';
                  }}
                  alt=''
                  onClick={(event: any) => {
                    if (event.target.classList.contains('image-error')) return;
                    window.open(item?.user?.avatar, '_blank');
                  }}
                />
              </div>
              <div className='user__info'>
                <div className='user__info__phone'>
                  {item?.user?.phoneNumber ?? 'N/A'}
                </div>
                <div className='user__info__name'>
                  {item?.user?.fullName ?? 'N/A'}
                </div>
              </div>
            </div>
          ),
        },
        {
          name: 'AMOUNT',
          key: 'value',
          render: (item: any) =>
            item?.value != null
              ? new Intl.NumberFormat('en').format(item?.value)
              : 'N/A',
        },
        {
          name: 'TYPE',
          key: 'transactionTypeName',
          render: (item: any) => item?.transactionTypeName ?? 'N/A',
        },
        {
          name: 'DESCRIPTION',
          key: 'description',
          render: (item: any) =>
            (item?.description ?? '') !== '' ? item?.description : 'N/A',
        },
        // {
        //     name: "BALANCE BEFORE",
        //     key: "balanceBefore",
        // },
        // {
        //     name: "BALANCE AFTER",
        //     key: "balanceAfter",
        // },
        {
          name: 'TRANSACTION CODE',
          key: 'transactionCode',
          render: (item: any) => item?.transactionCode ?? 'N/A',
        },
        {
          name: 'ACTION',
          key: 'actions',
          render: (item: any) => {
            return (
              <div className='action'>
                <div
                  className='action__edit'
                  onClick={() =>
                    navigate(Routes.transactionDetail.renderPath(item?.id))
                  }
                >
                  <Icon.ViewDetailIcon />
                </div>
              </div>
            );
          },
        },
      ];

      return (
        <div className='transaction-list'>
          <div className='button-container'>
            <Button
              label='Export excel'
              buttonType='success'
              className='mb15'
              onClick={async () => {
                const response = await AdminService.getListTransactions({
                  ...params,
                  page: 1,
                  pageSize: currentData?.count,
                });

                const fileHead = structure
                  .map((v) => v.name)
                  .filter((v: any) => v != 'ACTION');
                const dataExport = [
                  fileHead,
                  ...response.data.map((item: any) =>
                    structure.map((column, index) => {
                      if (!column.key) return '';
                      if (column.key === 'user') return item?.user?.phoneNumber;
                      return item[column.key];
                    }),
                  ),
                ];

                const ws = XLSX.utils.aoa_to_sheet(dataExport);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');

                const now = new Date();
                XLSX.writeFile(
                  wb,
                  `Transaction-List-${now.toLocaleDateString().replace(/\//g, '-')} ${now
                    .toLocaleTimeString()
                    .replace(/:/g, '-')}.xlsx`,
                  { type: 'binary' },
                );
              }}
            />
            {/* <div className="left-container">
                            <div className="admin-checkbox">
                                <div className="label">ADMIN ONLY</div>
                                <CheckboxCompnt 
                                    // value={} 
                                    checked={isCheckAdmin}
                                    onChange={(value: any, checked: any) => {
                                        setIsCheckAdmin(checked);
                                        setForceUpdateTable(state => !state);
                                    }}
                                />
                            </div>
                        </div> */}
          </div>
          <Table
            hasOrderColumn
            itemPerPages={10}
            filters={[
              {
                name: 'Phone',
                key: 'userPhone',
                input: TableFilterInputText,
              },
              {
                name: 'Name',
                key: 'userName',
                input: TableFilterInputText,
              },
              {
                name: 'Transaction code',
                key: 'transactionCode',
                input: TableFilterInputText,
              },
              {
                name: 'Time',
                key: 'created',
                input: (e) => (
                  <TableFilterRangeTimeInput
                    {...e}
                    fromKey='fromDate'
                    toKey='toDate'
                  />
                ),
                defaultValue: {
                  fromDate: startOfMonth, //new Date(last1MothDate),
                  toDate: endOfDay, //new Date(),
                },
              },
              {
                name: 'Type',
                key: 'transactionType',
                input: (s) => (
                  <TableFilterInputSelect
                    {...s}
                    options={BankService.getTransactionTypeOptions()}
                  />
                ),
              },
            ]}
            structure={structure}
            fetchData={async (params) => {
              setParams(params);
              return AdminService.getListTransactions({
                page: params.pageNumber,
                pageSize: params.limit,
                ...params,
              }).then((res) => {
                setCurrentData(res);
                return res;
              });
            }}
            forceUpdateTable={forceUpdateTable}
          />
        </div>
      );
    },
    () => true,
  ),
);
